import { useRef, useEffect, useCallback, useState } from 'react'
import gsap from 'gsap'

interface AnimatedCounterProps {
  value: number
  className?: string
  prefix?: string
  duration?: number
}

/**
 * Contador animado com easing suave
 * - Anima de valor anterior para novo
 * - Formatação BRL
 */
export function AnimatedCounter({
  value,
  className = '',
  prefix = '',
  duration = 1,
}: AnimatedCounterProps) {
  const spanRef = useRef<HTMLSpanElement>(null)
  const previousValue = useRef(value)
  const [displayValue, setDisplayValue] = useState(value)

  const formatValue = useCallback((val: number) => {
    return val.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    })
  }, [])

  useEffect(() => {
    const target = { val: previousValue.current }

    gsap.to(target, {
      val: value,
      duration,
      ease: 'power2.out',
      onUpdate: () => {
        setDisplayValue(target.val)
      },
      onComplete: () => {
        previousValue.current = value
      },
    })
  }, [value, duration])

  return (
    <span ref={spanRef} className={className}>
      {prefix}
      {formatValue(displayValue)}
    </span>
  )
}
